import { PureComponent } from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getStories, getAutoPlay, getUser } from 'shared/redux/reducers'
import { fetchTrendingStories, fetchMoreStories } from 'shared/redux/fetch-stories'
import { trackPageView } from 'shared/util/analytics'
import { Loader } from 'shared/components/preloader-animation'
import { getContext } from 'recompose'
import TrendingGifsCarousel from '../trending-gifs-carousel'
import TodaysVideos from './todays-videos'
import TodaysContentBlocks from './content-blocks'
import MobileArtistCarousel from '../artists/mobile-artist-carousel'
import { TrendingIcon, ArtistsIcon, ClipsIcon, StoriesIcon } from 'shared/components/homepage-icons'
import StoriesGrid from 'shared/components/story/grid-previews'
import HomepageHeader from 'shared/components/homepage-section-header'

const Container = styled.div`
    text-align: left;
`

@getContext({ isOffScreen: PropTypes.bool })
@connect(
    state => ({
        appWidth: state.appSize.width,
        autoPlay: getAutoPlay(state),
        trendingStories: getStories(state),
        hasCheckedLogin: (getUser(state) || {}).hasChecked || false,
    }),
    { fetchTrendingStories, fetchMoreStories }
)
export default class TrendingStories extends PureComponent {
    static propTypes = {
        username: PropTypes.string,
        showLatestLabel: PropTypes.bool,
        trendingStories: PropTypes.array,
        fetchTrendingStories: PropTypes.func.isRequired,
        showLatestStoryHeader: PropTypes.bool,
        hasCheckedLogin: PropTypes.bool,
    }
    static defaultProps = {
        trendingStories: [],
    }
    state = {
        page: 1,
        isFetching: false,
    }
    componentDidMount() {
        const { hasCheckedLogin, fetchTrendingStories } = this.props
        hasCheckedLogin && fetchTrendingStories()
    }
    componentDidUpdate({ hasCheckedLogin: prevHasCheckedLogin }) {
        const { hasCheckedLogin, fetchTrendingStories } = this.props
        if (hasCheckedLogin && hasCheckedLogin !== prevHasCheckedLogin) {
            fetchTrendingStories()
        }
    }
    onLoadMore = async () => {
        const { isOffScreen } = this.props
        const { page, isFetching } = this.state
        if (isFetching || isOffScreen) return
        const { fetchMoreStories } = this.props
        this.setState({ isFetching: true })
        await fetchMoreStories('trending')
        trackPageView(`/homepage/page/${page + 1}`)
        this.setState({
            page: page + 1,
            isFetching: false,
        })
    }
    render() {
        const { trendingStories, autoPlay, appWidth, pingbackId } = this.props
        const { isFetching } = this.state
        return (
            <Container>
                {!isEmpty(trendingStories) && (
                    <TrendingGifsCarousel
                        limit={50}
                        headerText={`Trending`}
                        icon={<TrendingIcon />}
                        isHomepage={true}
                    />
                )}
                {global.optimizeContentBlocksHomepage && <TodaysContentBlocks pingbackId={pingbackId} />}
                <MobileArtistCarousel width={223} icon={<ArtistsIcon />} />
                <TodaysVideos icon={<ClipsIcon />} />
                <HomepageHeader label="Stories" icon={<StoriesIcon />} />
                <StoriesGrid
                    stories={trendingStories}
                    width={appWidth}
                    noFeatured={false}
                    onLoadMore={this.onLoadMore}
                    autoPlay={autoPlay}
                />
                <Loader isFetching={isFetching} />
            </Container>
        )
    }
}
